<template>
	<div class="header">
		<div class="content">
			<div class="con-box">
				<div class="con-title">
					<img src="../../../static/img/logo2.png" width="409" @click="initPath" height="30" alt="" class="header-logo">
					<div class="divOpen">
						<!-- <i class="el-icon-information header-icon"></i> -->
						<img class="qrocode header-icon" src="../../../static/img/type0.png" v-if="type == 0">
						<img class="qrocode header-icon" src="../../../static/img/type1.png" v-if="type == 1">
						<img class="qrocode header-icon" src="../../../static/img/type2.png" v-if="type == 2">
						<img class="qrocode header-icon" src="../../../static/img/type3.png" v-if="type == 3">
						<span @click="searchDetail" style="cursor:pointer;" class="logout">{{name}}</span>
						<img class="qrocode header-icon" src="../../../static/img/qrcode.png">
						<div class="relative">
							<span @click="openqrcode" style="cursor:pointer;" class="logout">查看一企一码</span>
							<viewer class="viewer" :images="photo"> 
								<img    
										v-for="(src,index) in photo"
										:src="src"
										:key="index"
									>
							</viewer>
						</div>
						<i class="el-icon-circle-cross header-icon" style="margin-left:20px;margin-right:5px"></i>
						<a href="javascript:void(0)" @click="logout" class="logout">注销</a>
					</div>
				</div>
				<p style="clear: both;"></p>
			</div>
			<div class="menu">
				<div class="menu-box">
					<navMenu></navMenu>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import navMenu from './nav'
	import account from '../../data/ucenter/account.js'
	import { mapMutations, mapState } from 'vuex'
	export default {
		inject: ['reload'],
		components: {
			navMenu
		},
		data() {
			return {
				detail: {},
				detaillist: [],
				listPlanName: [],
				name: '',
				type:'',
				orgId:'',
				photo:[],
			}
		},
		watch: {
			dataNamelist() {
				if(!this.dataNamelist instanceof Array) return
				this.detaillist = this.dataNamelist
			},
			getComponyName() {
				this.name = this.getComponyName.value
				this.type = this.getComponyName.type
				this.orgId = this.getComponyName.id
				const subjectId = this.orgId
				this.photo = [`http://${window.location.host}/api/emer/subject/qrcode?subjectId=${subjectId}&planType=${'HeavyPollWeather'}`]
			}
		},
		computed: {
			...mapState({
				dataNamelist(state) {
					return state.dataNamelist
				},
				getComponyName(state) {
					return state.currentComponyName
				},
			})
		},
		created() {
			if(!sessionStorage.itemName) return
			this.name = JSON.parse(sessionStorage.itemName).value
			this.orgId = JSON.parse(sessionStorage.itemName).id
			this.type = JSON.parse(sessionStorage.itemName).type
			// this.type = JSON.parse(sessionStorage.orgStatus)
			//const subjectId = JSON.parse(sessionStorage['itemName']).id || ''
			const subjectId = this.orgId
			this.photo = [`http://${window.location.host}/api/emer/subject/qrcode?subjectId=${subjectId}&planType=${'HeavyPollWeather'}`]
		
			if(!sessionStorage.namalist) return
			this.listPlanName = sessionStorage.namalist;


		},
		mounted(){

		},
		methods: {
			...mapMutations(['changeIsRendering','changeCurVal','changeCurrUid']),
			initPath() {
				this.$router.push('/')
			},
			// 切换菜单
			changeMenus(val) {
				sessionStorage.itemName = JSON.stringify(val)
				this.name = val.value
				this.changeIsRendering(val.type)
				this.$router.push('/')
			},
			// 注销
			logout() {
				(async() => {
					let islogout = await account.logout()
					if(islogout) {
						this.$router.push('/login')
						sessionStorage.defaultPath = '/'
					} else {
						this.$message.error('注销失败');
					}
				})()
			},
			openqrcode () {
				let subjectId = JSON.parse(sessionStorage['itemName']).id
				window.open(`http://${window.location.host}/api/emer/subject/qrcode?subjectId=${subjectId}&planType=${'HeavyPollWeather'}`)
			},
			searchDetail(){
				let val = JSON.parse(sessionStorage.currently)
				sessionStorage.orgStatus = JSON.parse(JSON.stringify(val.type))
				sessionStorage.currenOrgId = val.id
				sessionStorage.currenOrgval = JSON.stringify(val)
				sessionStorage.currenrole = val.role
				this.changeCurrUid({
					uid: val.id,
					type: val.type
				})
				this.changeCurVal(val)
				if (this.$route.path == "/unitdetail") {
					// this.$router.go(0)
					this.reload()
				}else{
					this.$router.push('/unitdetail')
				}
			},
		}
	}
</script>
<style lang="stylus" scoped>
	.header {
		position: relative;
		z-index: 100;
		width: 100%;
		height: 95px;
		box-sizing: border-box;
		box-shadow: 2px 2px 20px #dddddd;
		background: url('../../../static/img/headerpublic.png') 100% 100% no-repeat;
		.content {
			width: 100%;
			height: 95px;
			margin: 0 auto;
			.header-logo {
				display: inline-block;
				float: left;
				margin-top: 5px;
				cursor: pointer;
			}
			.divOpen {
				float: right;
				height :40px;
				color: #fff;
				font-size: 14px;
				display:flex;
				align-items :center;
				justify-content :center;
				.header-icon{
					margin-right :5px;
					margin-left :20px;
				}
				.logout {
					color: #fff;
					&:hover {
						color: #666;
					}
				}
				.demo-badge {
					margin-top: 20px;
					margin-right: 5px;
					float: left;
					a {
						color: #333333;
						font-size: 16px;
						padding-left: 10px;
					}
				}
			}
		}
	}
	
	.el-dropdown-menu__item {
		height: 25px;
		line-height: 25px;
		text-align: center;
		font-size: 12px;
	}
	
	.con-box {
		width: 100%;
		height: 40px;
		background: #30a5db;
		.con-title {
			padding: 0 30px;
			margin: 0 auto
		}
	}
	
	.menu {
		width: 100%;
		height: 55px;
		background: #f1f1f3;
		.menu-box {
			padding: 0 30px;
			margin: 0 auto
		}
	}

	.qrocode {
		width:18px;
		height 18px;
		margin-right:10px;
	}

	.relative {
		position:relative;
	}

	.viewer {
		position:absolute;
		top:0;
		left:0;
		right:0;
		bottom:0;
		cursor:pointer;
	}

	.viewer img {
		width:100%;
		height:100%;
		opacity :0;
	}

	#drawing {
		position:fixed;
		top:0;
		left:0;
		z-index:20000;
	}
</style>


// WEBPACK FOOTER //
// Header.vue?da163f42